import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterLogs',
    standalone: false
})
export class FilterLogsPipe implements PipeTransform {

  transform(value: any[], ...args: string[]): any[] {
    if(!args){
      return [];
    }
    if(args[0]!=""){
      return value.filter((item: any) => item.serial.toUpperCase().indexOf(args[0].toUpperCase()) !== -1);
    }
    else{
      return value;
    }
  }

}
